<template>
  <div class="graphic-logo-content" id="identidade-visual-grafismos-logotipo-globo" data-search-anchor>
    <div class="graphic-logo-title-wrapper">
      <h1 class="graphic-logo-title-span">{{ graphicSymbolTitleSpan }}</h1>
      <h1 class="graphic-logo-title">{{ graphicSymbolTitle }}</h1>
    </div>
    <div class="description-graphic-logo-title-icons-wrapper">
      <p class="graphic-logo-description" style="margin-top: 0; margin-bottom: 0;">{{ graphicSymbolDescription1 }}</p>
      <p class="graphic-logo-description" style="margin-top: 0;">{{ graphicSymbolDescription2 }}</p>
      <div class="graphic-logo-icon-wrapper" style="width: 420px;">
        <IconCheck />
        <p class="graphic-logo-description-icon">{{ graphicSymbolDescription3 }}</p>
      </div>
      <div class="graphic-logo-icon-wrapper" style="width: 420px;">
        <IconCheck />
        <p class="graphic-logo-description-icon">{{ graphicSymbolDescription4 }}</p>
      </div>
    </div>
    <div class="graphic-logo-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicGraphicsLogoSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicSymbolTitleSpan(): string {
    return this.getElementTitle(4, 0)
  }

  get graphicSymbolTitle(): string {
    return this.getElementText(4, 0)
  }

  get graphicSymbolDescription1(): string {
    return this.getElementText(4, 1)
  }

  get graphicSymbolDescription2(): string {
    return this.getElementText(4, 2)
  }

  get graphicSymbolDescription3(): string {
    return this.getElementText(4, 3)
  }

  get graphicSymbolDescription4(): string {
    return this.getElementText(4, 4)
  }

  get graphicSymbolDescription5(): string {
    return this.getElementText(4, 5)
  }

  get ImageSrc(): string {
    return this.getElementMedia(4, 5)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-logo-content {
  display: grid;
}

.graphic-logo-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.graphic-logo-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.graphic-logo-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-graphic-logo-title-icons-wrapper {  
  position: relative;
  align-items: flex-start;
  display: grid;
  grid-template-columns: 51.2% 48.8%;  
}

.graphic-logo-description,
.graphic-logo-description-icon {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
  
  width: 430px;
}

.graphic-logo-description-icon {
  padding-left: 7px;
}

.graphic-logo-icon-wrapper {
  display: flex;
  align-items: center;
}

.graphic-logo-card-item {
  position: relative;
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

</style>
